import React from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import './embla.css';
import { localImages } from '../utils/remoteimages.js';
import { DotButton, useDotButton } from './EmblaCarouselDotButton';
import { PrevButton, NextButton, usePrevNextButtons } from './EmblaCarouselArrowButtons';

type LocalImageKeys = keyof typeof localImages;

type CardType = {
  model: LocalImageKeys;
  image: string;
  duration: string;
  seats: string;
  cost: string;
};

type EmblaCarouselProps = {
  cards: CardType[];
  options: any;
};

const EmblaCarousel: React.FC<EmblaCarouselProps> = ({ cards, options }) => {
  const [emblaRef, emblaApi] = useEmblaCarousel(options);

  const { selectedIndex, scrollSnaps, onDotButtonClick } = useDotButton(emblaApi);
  const { prevBtnDisabled, nextBtnDisabled, onPrevButtonClick, onNextButtonClick } = usePrevNextButtons(emblaApi);

  return (
    <div className="embla" ref={emblaRef}>
      <div className="embla__container">
        {cards.map((card: CardType, index: number) => (
          <div className="embla__slide" key={index}>
            <div className="jet-tile">
              <img
                src={
                  localImages[card.model.toLowerCase().replace(/\s+/g, '_') as LocalImageKeys]
                    ? `http://jetleg.ai${localImages[card.model.toLowerCase().replace(/\s+/g, '_') as LocalImageKeys].src}`
                    : '/jet_any.jpg'
                }
                alt={card.model}
              />
              <table className="jet-info">
                <tbody>
                  <tr>
                    <td className="jet-info-label">Model:</td>
                    <td className="jet-info-value">{card.model}</td>
                  </tr>
                  <tr>
                    <td className="jet-info-label">Duration:</td>
                    <td className="jet-info-value">{card.duration}</td>
                  </tr>
                  <tr>
                    <td className="jet-info-label">Seats:</td>
                    <td className="jet-info-value">{card.seats}</td>
                  </tr>
                  <tr>
                    <td className="jet-info-label">Cost:</td>
                    <td className="jet-info-value">{card.cost}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        ))}
      </div>
      <div className="embla__controls">
        <div className="embla__buttons">
          <PrevButton onClick={onPrevButtonClick} disabled={prevBtnDisabled} />
          <NextButton onClick={onNextButtonClick} disabled={nextBtnDisabled} />
        </div>
        <div className="embla__dots">
          {scrollSnaps.map((_: number, index: number) => (
            <DotButton
              key={index}
              onClick={() => onDotButtonClick(index)}
              className={`embla__dot embla-dot-${index}`}
              selected={index === selectedIndex}
            >
              {index + 1}
            </DotButton>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EmblaCarousel;
